const buildFormData = (formData, data, parentKey) => {
  if (data === 0 || data === false) {
    formData.append(parentKey, data);
  } else if (data && Array.isArray(data)) {
    data.forEach((value, index) => {
      buildFormData(formData, value, `${parentKey}[${index}]`);
    });
  } else if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}.${key}` : key);
    });
  } else {
    if (data !== null && data !== undefined) {
      formData.append(parentKey, data);
    }
  }
};

export const jsonToFormData = (data) => {
  const formData = new FormData();

  buildFormData(formData, data);

  return formData;
}